import firebase from 'firebase'
import { airtableConfig } from '@/config.js'
const base = airtableConfig.base

export const user = {
  state: {
    user: null,
    userEmployeeRecord: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setUserEmployeeRecord (state, payload) {
      state.userEmployeeRecord = payload
    }
  },
  actions: {
    setUser ({ commit }, payload) {
      return commit('setUser', payload)
    },
    async setUserEmployeeRecord ({ commit }) {
      console.log('setting user record...')
      const getUserRecord = firebase.functions().httpsCallable('getUserRecord')
      const userRecord = await getUserRecord({ base: base })
      return commit('setUserEmployeeRecord', userRecord.data)
    }
  },
  getters: {
    getUser (state) {
      return state.user
    },
    getUserEmployeeRecord (state) {
      return state.userEmployeeRecord
    }
  }
}
